window.axios = require('axios').default;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
require('bootstrap');
var $ = require( "jquery" );
window.$ = window.jQuery = require('jquery');

window.Vue = require('vue');
Vue.component('value-calculator', require('./components/value-calculator').default);
Vue.component('value-calculator-steps', require('./components/value-calculator-steps').default);


Vue.component('dist-calculator', require('./components/distribution-calculator').default);


const app = new Vue({
    el: '#app',
});

Vue.directive('tooltip', function(el, binding){
    el.setAttribute('data-toggle', 'tooltip')
    console.log(el);
    $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: 'hover'
    })
})


$(document).on('submit','#pdf-modal form',function (){
    var data = {
        submissionId: $('#submissionId').val(),
        firstname: $('#pdf-modal form input[name="firstname"]').val(),
        lastname:  $('#pdf-modal form input[name="lastname"]').val(),
        email: $('#pdf-modal form input[name="email"]').val(),
    };
    $.post('/actions/valuecalc/valuecalc/savename', data, function (response){
        console.log(response);
    },'json');
});